import React from "react";
import { PrimitiveAtom, useAtom } from "jotai";
import { calibrationsStateAtoms } from "./state";
import { Directions, color } from "./primitives";

const shorten = (txt: string): string => txt.split(",")[0];

const DirectionsRow = ({
	directionAtom,
	remove,
}: {
	directionAtom: PrimitiveAtom<Directions>;
	remove: () => void;
}) => {
	const [direction] = useAtom(directionAtom);
	return (
		<li style={{ backgroundColor: color(direction) }}>
			<p>
				from: {shorten(direction.fromLabel)} to: {shorten(direction.toLabel)}
			</p>
			<button className="remove" onClick={remove}>
				remove
			</button>
		</li>
	);
};

const ListEditor = ({ toggled }: { toggled: boolean }) => {
	const [directions, dispatch] = useAtom(calibrationsStateAtoms);
	return (
		<ul data-toggled={toggled} className="directions-list">
			{directions.map((directionsAtom) => {
				return (
					<DirectionsRow
						key={directionsAtom.toString()}
						directionAtom={directionsAtom}
						remove={() => dispatch({ type: "remove", atom: directionsAtom })}
					/>
				);
			})}
		</ul>
	);
};

export default ListEditor;
